import { FeatureFlag } from '@/hooks/useFeatureFlags'

import { selectVideoWallIsOpen } from '@/redux/videoWall/videoWallSlice'

import { DarkModeFtuToggle } from '../components/DarkModeFtuToggle'
import type { FtuConfig } from '../types/types'

// Announces the dark-mode default (ENG-33714) and embeds the same toggle as
// Settings > Account Management so the user can switch back to light mode
// without leaving the modal. Gated on the dark-mode toggle flag; note that on
// main `useLightMode` also requires FeatureFlag.development — ENG-33713 aligns
// it to showDarkModeToggle alone.
const darkModeFtu: FtuConfig = {
  id: 'dark-mode-v1',
  featureFlag: FeatureFlag.showDarkModeToggle,
  steps: [
    {
      kind: 'neutral',
      id: 'welcome',
      titleKey: 'first_time_use:dark_mode.welcome_title',
      bodyKey: 'first_time_use:dark_mode.welcome_body',
      bodyComponent: DarkModeFtuToggle,
    },
  ],
}

// The video wall is a global overlay opened with the "W" key, so there is no
// on-screen control to point at — the tour teaches the shortcut and gates on the
// resulting state. "Using it" means opening it, so the gated step waits until
// the wall is open, latches (toggling it closed again won't re-block Finish),
// and auto-advances the instant it opens.
const videoWallFtu: FtuConfig = {
  id: 'video-wall-v1',
  featureFlag: FeatureFlag.videoWall,
  steps: [
    {
      kind: 'neutral',
      id: 'welcome',
      titleKey: 'first_time_use:video_wall.welcome_title',
      bodyKey: 'first_time_use:video_wall.welcome_body',
    },
    {
      kind: 'gated',
      id: 'try-it',
      titleKey: 'first_time_use:video_wall.try_title',
      bodyKey: 'first_time_use:video_wall.try_body',
      isComplete: selectVideoWallIsOpen,
      latch: true,
      autoAdvanceOnComplete: true,
    },
    {
      kind: 'neutral',
      id: 'done',
      titleKey: 'first_time_use:video_wall.done_title',
      bodyKey: 'first_time_use:video_wall.done_body',
    },
  ],
}

// TODO! In future we'll need to be more tactful in how/when we show these. I don't think we'll want a new user to sign
//  into HiveWatch for the very first time and see 15 different FTUs covering features that they're not even aware of.

// Ordered by priority — the first eligible tour is shown. Completing one tour
// immediately surfaces the next eligible one (see the TODO above).
export const FTU_REGISTRY: FtuConfig[] = [darkModeFtu, videoWallFtu]
